module.exports = "/_next/static/images/03-cebc8657c06a5730e481a6546d822627.png";